import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeesListRouting } from './employess.routing';
import { EmployeesListComponent } from './employee-list/employees-list.component';
import { EmployeesRest } from './employee.rest';
import { SharedModule } from '../../core/shared/shared.module';
import { TimesheetPrintoutConfigModalComponent } from './employee-list/timesheet-printout-config-modal/timesheet-printout-config-modal.component';

@NgModule({
  imports: [
    CommonModule,
    EmployeesListRouting,
    SharedModule
  ],
  declarations: [
    EmployeesListComponent,
    TimesheetPrintoutConfigModalComponent
  ],
  providers: [EmployeesRest]
})
export class EmployeesModule { }